module.exports = __webpack_public_path__ + "img/材料力学5_6.0c9971d0.jpg";